export default [
  {
    name: '大数据平台',
    children: [
      {
        sonName: '大数据平台',
        routerUrl: '/screen',
        status: true
      }
    ],
    status: false,
    imgUrl: require('../icons-img/cpt.png')
  },
  {
    name: '监控平台',
    children: [],
    status: false,
    imgUrl: require('../icons-img/jiankong.png')
  },
  {
    name: '终端管理',
    status: false,
    imgUrl: require('../icons-img/shebeixiangqing.png'),
    children: [
      {
        sonName: '终端管理',
        component: 'newsSafe',
        status: false
      }
    ]
  },
  {
    name: '学生证管理',
    status: false,
    imgUrl: require('../icons-img/shebeixiangqing.png'),
    children: [
      {
        sonName: '学生证管理',
        component: 'newsSafe',
        status: false
      }
    ]
  },
  {
    name: '统计报表',
    status: false,
    imgUrl: require('../icons-img/wj-rz.png'),
    children: [
      {
        sonName: '通话时长统计',
        component: 'CommunicationTime',
        status: false
      },
      {
        sonName: '检测异常统计',
        component: 'Yichang',
        status: true
      },
      {
        sonName: '通话记录统计',
        component: 'Callrecords',
        status: false
      },
      {
        sonName: '报警统计报表',
        component: 'regularitySchool',
        status: false
      },
      {
        sonName: '售后管理报表',
        component: 'Aftersales',
        status: false
      },
      {
        sonName: '设备管理报表',
        component: 'Equipment',
        status: false
      },
      {
        sonName: '考勤消息报表',
        component: 'Attendance',
        status: false
      },
      {
        sonName: '服务热线统计报表',
        component: 'Servicehotline',
        status: false
      },
      {
        sonName: '报警详单报表',
        component: 'Alarmdetail',
        status: false
      },
      {
        sonName: '运动计步报表',
        component: 'Sportsreport',
        status: false
      },
      {
        sonName: '日志报表',
        component: 'AournalSheet',
        status: false
      },
      {
        sonName: '活跃用户统计',
        component: 'Activeuser',
        status: false
      },
      {
        sonName: '电量统计',
        component: 'Electricity',
        status: false
      }
    ]
  },
  {
    name: '家长账号管理',
    status: false,
    imgUrl: require('../icons-img/huiyuan.png'),
    children: [
      {
        sonName: '家长账号管理',
        component: 'RegisteredMember',
        status: false
      }
    ]
  },
  {
    name: '校园管理',
    status: false,
    imgUrl: require('../icons-img/xiaoyuan.png'),
    children: [
      {
        sonName: '学校组织管理',
        component: 'ManagementSchool',
        status: false
      },
      {
        sonName: '学生管理',
        component: 'StudentGuanli',
        status: false
      },
      {
        sonName: '教师管理',
        component: 'TeatcherGuanli',
        status: false
      },
      {
        sonName: '宿舍管理员',
        component: 'SuSheGuanLi',
        status: false
      },
      {
        sonName: '保安管理',
        component: 'AskariGuanLi',
        status: false
      }
    ]
  },
  {
    name: '考勤管理',
    status: false,
    imgUrl: require('../icons-img/kq_control.png'),
    children: [
      {
        sonName: '请假管理',
        component: 'StudentLeave',
        status: false
      },
      {
        sonName: '考勤记录',
        component: 'CheckGuanli',
        status: false
      },
      {
        sonName: '考勤统计（日）',
        component: 'CheckTongji',
        status: false
      },
      {
        sonName: '考勤统计（月）',
        component: 'StudentKQ',
        status: true
      },
      {
        sonName: '学生人脸图库',
        component: 'StudentManage',
        status: false
      },
      {
        sonName: '教师人脸图库',
        component: 'TeatcherManage',
        status: false
      },
      {
        sonName: '读卡器管理',
        component: 'CardreaDing',
        status: false
      },
      {
        sonName: '读卡点管理',
        component: 'CardreaDingPoint',
        status: false
      },
      {
        sonName: '通行策略',
        component: 'TxStrategy',
        status: true
      },
      {
        sonName: '考勤时间管理',
        component: 'KaoqinTime',
        status: false
      },
      {
        sonName: '考勤短信管理',
        component: 'KaoqinNote',
        status: false
      }
    ]
  },
  {
    name: '教务管理',
    status: false,
    imgUrl: require('../icons-img/xuexiao_jiaoshi.png'),
    children: [
      {
        sonName: '校园公告',
        component: 'SchoolAffiche',
        status: false
      },
      {
        sonName: '家庭作业',
        component: 'Homework',
        status: false
      },
      {
        sonName: '学科管理',
        component: 'ClassAdmin',
        status: false
      },
      {
        sonName: '课堂测试',
        component: 'roomCeshi',
        status: false
      },
      {
        sonName: '考试成绩管理',
        component: 'ExamKaoshi',
        status: false
      },
      {
        sonName: '安全教育和新闻',
        component: 'Anquaneducation',
        status: false
      },
      {
        sonName: '九学王',
        component: '',
        status: false
      }
    ]
  },
  {
    name: '健康管理',
    status: false,
    imgUrl: require('../icons-img/jiankangguanli.png'),
    children: [
      {
        sonName: '步数管理',
        component: 'stepCountManagement',
        status: false
      },
      {
        sonName: '心率管理',
        component: 'heartRateManagement',
        status: false
      },
      {
        sonName: '体温管理',
        component: 'bodyTemperatureManagement',
        status: false
      },
      {
        sonName: '血氧管理',
        component: 'bloodOxygenManagement',
        status: false
      },
      {
        sonName: '血压管理',
        component: 'bloodPressureManagement',
        status: false
      }
    ]
  },
  {
    name: '德育管理',
    status: false,
    imgUrl: require('../icons-img/deyu.png'),
    children: [
      {
        sonName: '考核任务',
        component: 'Task',
        status: false
      },
      {
        sonName: '考核记录',
        component: 'Record',
        status: false
      },
      {
        sonName: '考核统计',
        component: 'Tongji',
        status: false
      },
      {
        sonName: '德育档案',
        component: 'Dangan',
        status: false
      },
      {
        sonName: '德育报表',
        component: 'Forms',
        status: false
      }
    ]
  },
  {
    name: '校舍管理',
    status: false,
    imgUrl: require('../icons-img/sushe.png'),
    children: [
      {
        sonName: '宿舍楼栋',
        component: 'LouDong',
        status: false
      },
      {
        sonName: '宿舍管理',
        component: 'SusheManagement',
        status: false
      },
      {
        sonName: '进出记录',
        component: 'SusheRecord',
        status: false
      }
    ]
  },
  {
    name: '日志管理',
    status: false,
    imgUrl: require('../icons-img/shujubaobiao.png'),
    children: [
      {
        sonName: '上行日志',
        component: 'Uplinklog',
        status: false
      },
      {
        sonName: '下行日志',
        component: 'Downlinklog',
        status: false
      },
      {
        sonName: '登录日志',
        component: 'Entrylog',
        status: false
      },
      {
        sonName: '考勤日志',
        component: 'CheckLog',
        status: false
      }
    ]
  },
  {
    name: '系统设置',
    status: false,
    imgUrl: require('../icons-img/xitong.png'),
    children: [
      {
        sonName: '健康设置',
        component: 'healthSettings',
        status: true
      },
      {
        sonName: '公司信息管理',
        component: 'Corporateinformation',
        status: false
      },
      {
        sonName: '围栏设置',
        component: 'Railset',
        status: false
      },
      {
        sonName: '系统角色管理',
        component: 'Rolemanagement',
        status: false
      },
      {
        sonName: '定时开关机设置',
        component: 'Switchsettings',
        status: false
      },
      {
        sonName: '隐身设置',
        component: 'StealthSettings',
        status: false
      },
      {
        sonName: '系统用户管理',
        component: 'Usermanagement',
        status: false
      },
      {
        sonName: '定位信息管理',
        component: 'Locationmanagement',
        status: false
      },
      {
        sonName: '定时跟踪设置',
        component: 'TimingTracking',
        status: false
      },
      {
        sonName: '数字字典设置',
        component: 'Shuzimanagement',
        status: false
      }
    ]
  },
  {
    name: '组织管理',
    status: false,
    imgUrl: require('../icons-img/xiaoyuan.png'),
    children: [
      {
        sonName: '组织架构',
        component: 'zuzhiJiagou',
        status: false
      },
      {
        sonName: '成员管理',
        component: 'memberGuanli',
        status: false
      },
      {
        sonName: '管理员设置',
        component: 'gliyuanSettings',
        status: false
      }
    ]
  },
  {
    name: '事务管理',
    status: false,
    imgUrl: require('../icons-img/xuexiao_jiaoshi.png'),
    children: [
      {
        sonName: '平台公告',
        component: 'pingTai',
        status: false
      },
      {
        sonName: '健康管理合新闻',
        component: 'jianKang',
        status: false
      }
    ]
  }
]
